module.exports = __webpack_public_path__ + "img/Argentina.28840014.png";